import React, {FC, useEffect, useState} from 'react';
import * as fonts from '../../../../../util/fonts';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import './styles.scss';
import {functionalitiesAliasMap, strings} from '../../../../../util/strings';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {
  formatEstimatedPrice,
  getColor,
  getCurrencyCode,
} from '../../../../../util/utility';
import {Row} from '../../../../../components/layout';
import AppSpinner from '../../../../../components/app-spinner';

interface TabDetailsProps {
  buStyles: any;
  procedure: any;
  dataList: any;
  expanded: any;
  speciality: any;
  labels: typeof strings.pt.rede;
  handleChange(value: any): any;
  clickFunction?(value: any): any;
  listEmpty: boolean;
  loading: boolean;
  index: number;
  redirectToMedicDetails?(value: any): any;
  loadMedics?: boolean;
  medicsList?: any;
  busFuncMap: any;
  selectedBu: any;
  prices?: any[];
  resetPrices?(value: any): any;
  filtered?: boolean;
  selectedCategoryCode?: number;
  selectedSpecialtyCode?: number;
  appendedNameForExamFiltered?: string;
}

const TabDetails: FC<TabDetailsProps> = ({
  labels,
  expanded,
  buStyles,
  procedure,
  dataList,
  speciality,
  handleChange,
  listEmpty,
  loading,
  clickFunction,
  redirectToMedicDetails,
  loadMedics,
  medicsList,
  index,
  selectedBu,
  busFuncMap,
  prices,
  resetPrices,
  filtered,
  selectedCategoryCode,
  selectedSpecialtyCode,
  appendedNameForExamFiltered,
}) => {
  const [appendProcedureName, setAppendProcedureName] = useState('');
  const [specialityName, setSpecialityName] = useState(speciality);
  const [displayMedics, setDisplayMedics] = useState(false);
  const [noMedics, setNoMedics] = useState(false);
  const [list, setList] = useState(dataList);

  const precoEstimadoFunc = busFuncMap[selectedBu.buId].find(
    (item: any) =>
      item.featureTemplateAlias === functionalitiesAliasMap?.redePrecos
  );
  const precoEstimadoFuncAtiva = precoEstimadoFunc
    ? precoEstimadoFunc?.isVisible
    : false;

  const resetTab = () => {
    resetPrices && resetPrices('exams');
    setAppendProcedureName('');
    setDisplayMedics(false);
    setNoMedics(false);
  };

  useEffect(() => {
    if (
      filtered &&
      selectedCategoryCode === parseInt(labels.medicalNetwork_exams_code)
    ) {
      setSpecialityName(appendedNameForExamFiltered);
      setDisplayMedics(true);
    } else {
      const appendedName = appendProcedureName
        ? `${speciality} / ${appendProcedureName}`
        : speciality;
      setSpecialityName(appendedName);
    }

    if (appendProcedureName) {
      setDisplayMedics(true);
    }
  }, [appendProcedureName, appendedNameForExamFiltered]);

  useEffect(() => {
    if (displayMedics) {
      setList(medicsList);
      setNoMedics(medicsList.length === 0);
    } else {
      setList(dataList);
    }
  }, [displayMedics, dataList, medicsList]);

  useEffect(() => {
    resetTab();
  }, [expanded]);

  const renderTextResetAction = () => {
    return (
      displayMedics && (
        <div className="view-all-acts-container">
          <a
            onClick={resetTab}
            style={{...fonts.SM, ...fonts.SemiBold, ...getColor('color')}}
            className="view-all-acts">
            {labels?.medicalNetwork_clinicDetail_viewAllActsIn} {speciality}
          </a>
        </div>
      )
    );
  };

  const redirectToMedicInfo = (element: any) => {
    if (appendProcedureName) {
      redirectToMedicDetails && redirectToMedicDetails(element);
    } else if (loadMedics) {
      setAppendProcedureName(element.name);
    }
  };

  const findPrice = (code: number) => {
    let currPrice = prices?.find((item: any) => item.code === code);
    if (currPrice) {
      let currPriceExists = currPrice !== '' && !!currPrice.price;
      return currPriceExists
        ? `${formatEstimatedPrice(currPrice.price)} ${getCurrencyCode(
            undefined,
            'rede'
          )}`
        : '-';
    } else {
      return '';
    }
  };
  return (
    <Accordion
      expanded={expanded === procedure.code}
      onChange={handleChange(procedure.code)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon htmlColor={buStyles.primaryColor} />}
        className="accordion-panel1a"
        aria-controls="panel1a-content"
        id={`panel1a-header-${procedure.code}`}>
        <Typography>
          <Row className="accordeon-title-row">
            <span style={{...fonts.M, ...fonts.Bold}}>{specialityName}</span>
            {precoEstimadoFuncAtiva &&
              prices &&
              findPrice(procedure.code) !== '' && (
                <div className="estimated-price-container-tabs">
                  <span
                    style={{...fonts.M, ...fonts.Bold}}
                    className={
                      findPrice(procedure.code) === ''
                        ? 'no-price-estimated'
                        : 'estimated-price-tabs'
                    }>
                    {findPrice(procedure.code)}
                  </span>
                </div>
              )}
          </Row>
        </Typography>
      </AccordionSummary>
      {renderTextResetAction()}
      <AccordionDetails>
        {(listEmpty || noMedics) && !loading && (
          <div className="options-no-results" style={{...fonts.M}}>
            {labels?.medicalNetwork_clinics_speciality_noResults}
          </div>
        )}
        {(!listEmpty || !noMedics) && !loading && (
          <Typography>
            <div className="options-container">
              {list?.map((element: any) => (
                <>
                  <div className="option" key={element.name}>
                    <div
                      className={
                        clickFunction ? 'option-title' : 'option-title-no-hover'
                      }
                      style={
                        clickFunction
                          ? {
                              ...fonts.M,
                              ...fonts.Bold,
                              color: buStyles.primaryColor,
                            }
                          : {
                              ...fonts.M,
                              color: buStyles.black,
                            }
                      }
                      onClick={() => {
                        if (redirectToMedicDetails) {
                          redirectToMedicInfo(element);
                        }
                        if (clickFunction) {
                          clickFunction(element);
                        }
                      }}>
                      {element.name}
                    </div>
                  </div>
                </>
              ))}
            </div>
          </Typography>
        )}
        {loading && (
          <Row className="tab-spinner">
            <AppSpinner />
          </Row>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

const mapStateToProps = ({
  globalStyles,
  strings,
  selectedBu,
  busFuncMap,
}: any) => ({
  buStyles: globalStyles.value,
  labels: strings.value.pt.rede,
  selectedBu: selectedBu.value,
  busFuncMap: busFuncMap.value,
});

export default compose(connect(mapStateToProps)(TabDetails));
